import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/lib/auth';

/**
 * Wrapper que requiere sesión activa. Si no la hay, redirige a /login
 * preservando el destino en query string para volver tras autenticarse.
 */
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data: session, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-accent border-t-transparent" />
      </div>
    );
  }

  if (!session) {
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirectTo}`} replace />;
  }

  return <>{children}</>;
}
